export default __webpack_public_path__ + "2b020dccd35432ce27689ffbba8fe4a0.ttf";